import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import { useLang } from "../contexts/LanguageContext";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from "../components/ui/alert-dialog";
import { Timer, Award, Clock, ListChecks } from "lucide-react";

export default function MockExam() {
  const { t } = useLang();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const start = () => navigate("/quiz?mode=mock");

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar/>
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <h1 data-testid="mock-title" className="text-3xl sm:text-4xl font-bold tracking-tight mb-2">{t("mockTitle")}</h1>
        <p className="text-gray-600 mb-10">{t("mockSubtitle")}</p>

        <Card className="p-8 sm:p-10 bg-fjord text-white relative overflow-hidden mb-8">
          <div className="absolute -end-20 -top-20 w-60 h-60 rounded-full bg-white/5"></div>
          <div className="absolute -end-12 -bottom-12 w-44 h-44 rounded-full bg-white/5"></div>
          <Timer className="w-10 h-10 mb-4"/>
          <h2 className="font-heading text-3xl font-bold mb-3">{t("fullMockExam")}</h2>
          <p className="text-white/80 mb-8 max-w-xl">{t("confirmMock")}</p>
          <div className="grid grid-cols-3 gap-3 max-w-sm mb-8">
            <Stat icon={<ListChecks className="w-4 h-4"/>} label="Q's" val="45"/>
            <Stat icon={<Clock className="w-4 h-4"/>} label={t("minutes")} val="90"/>
            <Stat icon={<Award className="w-4 h-4"/>} label="Pass" val="38/45"/>
          </div>
          <AlertDialog open={open} onOpenChange={setOpen}>
            <AlertDialogTrigger asChild>
              <Button data-testid="open-mock-confirm" size="lg" variant="secondary" className="bg-white text-fjord hover:bg-gray-100">
                <Timer className="w-4 h-4 me-2"/> {t("startMock")}
              </Button>
            </AlertDialogTrigger>
            <AlertDialogContent>
              <AlertDialogHeader>
                <AlertDialogTitle>{t("fullMockExam")}</AlertDialogTitle>
                <AlertDialogDescription>{t("confirmMock")}</AlertDialogDescription>
              </AlertDialogHeader>
              <AlertDialogFooter>
                <AlertDialogCancel data-testid="cancel-mock">{t("cancel")}</AlertDialogCancel>
                <AlertDialogAction data-testid="confirm-mock" onClick={start} className="bg-fjord hover:bg-fjord-700">
                  {t("iAmReady")}
                </AlertDialogAction>
              </AlertDialogFooter>
            </AlertDialogContent>
          </AlertDialog>
        </Card>
      </main>
    </div>
  );
}

function Stat({icon, label, val}) {
  return (
    <div className="bg-white/10 rounded-lg p-3 backdrop-blur">
      <div className="flex items-center gap-1.5 text-xs text-white/70 mb-1">{icon}<span>{label}</span></div>
      <div className="font-heading text-2xl font-bold">{val}</div>
    </div>
  );
}
